import { FC, useCallback } from "react";
import { useDidMount } from "rooks";
import { Box } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { CommitmentsTabSwitcher } from "@/components/pages/commtiments/common/components/tag-switcher/CommitmentsTabSwitcher";
import { commitmentsDataViewTabSelector } from "@/store/commitments/selectors/common/view-options/commitmentsDataViewTabSelector";
import { setCommitmentsDataViewTab } from "@/store/commitments/commitmentsSlice";
import { DataViewTab } from "@/store/commitments/utils/types/types";
import {
  useGetUsersMeOrganisationsCurrentReservationsPotentialSavingsQuery,
  useGetV2UsersMeOrganisationsCurrentSavingsPlansPotentialSavingsQuery,
} from "@/services/cloudchipr.api";
import { commitmentsCurrentOrgIdSelector } from "@/store/commitments/selectors/common/commitmentsCurrentOrgIdSelector";
import { money } from "@/utils/numeral/money";

export const RecommendationsTabs: FC = () => {
  const dispatch = useAppDispatch();
  const tab = useAppSelector(commitmentsDataViewTabSelector);
  const orgId = useAppSelector(commitmentsCurrentOrgIdSelector);

  const { data: reservationsPotentialSavings } =
    useGetUsersMeOrganisationsCurrentReservationsPotentialSavingsQuery({
      providerOrganisationId: orgId,
    });
  const { data: savingPlanPotentialSaving } =
    useGetV2UsersMeOrganisationsCurrentSavingsPlansPotentialSavingsQuery({
      providerOrganisationId: orgId,
    });
  const tabChangeHandler = useCallback(
    (tab: string) => {
      dispatch(setCommitmentsDataViewTab(tab as DataViewTab));
    },
    [dispatch],
  );

  useDidMount(() => {
    if (tab !== "saving_plans" && tab !== "reservation") {
      dispatch(setCommitmentsDataViewTab("saving_plans"));
    }
  });

  const reservationLabel = reservationsPotentialSavings?.savings_amount
    ? `(Savings ~${money(reservationsPotentialSavings?.savings_amount)}/mo)`
    : "";
  const savingPlanLabel = savingPlanPotentialSaving?.savings_amount
    ? `(Savings ~${money(savingPlanPotentialSaving?.savings_amount)}/mo)`
    : "";

  const tabs = [
    {
      label: `SP Recommendations ${savingPlanLabel}`,
      value: "saving_plans",
    },
    {
      label: `RI Recommendations ${reservationLabel} `,
      value: "reservation",
    },
  ];
  return (
    <Box px={1}>
      <CommitmentsTabSwitcher
        tabs={tabs}
        onTabChange={tabChangeHandler}
        value={tab}
      />
    </Box>
  );
};
